// `CMSItem` is the type name for CMS items in the GraphQL schema.
export function isCmsItemTypeName(gqlTypeName: string) {
  return gqlTypeName === 'CMSItem';
}
